import { Typography, Grid } from '@mui/material';

const RoamingSuccessRateInfo = ({ successRateInfo }) => {
  return (
    <Grid container spacing={2} sx={{ p: 1 }}>
      <Grid item xs={5.5}>
        <Typography variant="body2" sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5 }}>
          Status
        </Typography>
        {successRateInfo?.status === '-' && <Typography sx={{ fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>-</Typography>}
        {successRateInfo?.status === 'Good' && <Typography sx={{ color: '#2e7d32', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>Good</Typography>}
        {successRateInfo?.status === 'Warning' && (
          <Typography sx={{ color: '#FF9800', fontWeight: 600, fontSize: '35px', lineHeight: 1.2, letterSpacing: '-1.5px' }}>Warning</Typography>
        )}
        {successRateInfo?.status === 'Critical' && <Typography sx={{ color: '#F44336', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>Critical</Typography>}
      </Grid>

      <Grid item xs={6.5}>
        <Typography variant="body2" sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5 }}>
          Success Rate (≤ 2s)
        </Typography>
        <Typography sx={{ color: '#1a237e', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>{successRateInfo?.successRate}</Typography>
      </Grid>

      <Grid item xs={5.5} sx={{ mt: { xs: 1, sm: 1.5 } }}>
        <Typography variant="body2" sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5 }}>
          Total Events
        </Typography>
        <Typography sx={{ color: '#1a237e', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>{successRateInfo?.totalEvents}</Typography>
      </Grid>

      <Grid item xs={6.5} sx={{ mt: { xs: 1, sm: 1.5 } }}>
        <Typography variant="body2" sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5 }}>
          95% Roams Complete Within
        </Typography>
        <Typography sx={{ color: '#1a237e', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>{successRateInfo?.p95Latency}</Typography>
      </Grid>
    </Grid>
  );
};

export default RoamingSuccessRateInfo;
